import { Directive, TemplateRef, inject } from '@angular/core';

@Directive({ selector: '[ishLazyLoadingContent]' })
export class LazyLoadingContentDirective {
  templateRef = inject<TemplateRef<unknown>>(TemplateRef);
}
